module.exports = __webpack_public_path__ + "img/help.47cbfe7d.png";